const colors = {
  colors: {
    brand: {
      caramel: '#D87D4A',
      night: '#101010',
      antiFlashWhite: '#F1F1F1',
      seaSalt: '#FAFAFA',
      atomicTangerine: '#FBAF85',
    },
    component: {
      fireEngineRed: '#CD2C2C',
      davyGrey: '#4C4C4C',
    },
  },
};

export default colors;
